import { render, staticRenderFns } from "./BorcRiskSiparisBilgileri.vue?vue&type=template&id=3362b0b2&scoped=true"
import script from "./BorcRiskSiparisBilgileri.vue?vue&type=script&lang=js"
export * from "./BorcRiskSiparisBilgileri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3362b0b2",
  null
  
)

export default component.exports